<template>
  <div>
    <div class="infobox" id="contact_info_box" :class="{ inactive: !active }">
      <div class="ib-header">
        <div class="infobox-badge text_size-medium text_style-bold">
          {{ badge }}
        </div>
        <div>
          <div class="title text_size-medium-small">{{ title }}</div>
          <div class="subtitle">{{ subtitle }}</div>
        </div>
        <div
          v-if="closed && active"
          @click="$emit('opened')"
          class="edit text_size-medium"
        >
          Edit
        </div>
      </div>
      <transition name="slide-vertical">
        <div class="ib-content" v-if="!closed">
          <slot name="active"></slot>
        </div>
      </transition>
      <transition name="slide-vertical">
        <div class="ib-content-summary" v-if="closed">
          <slot name="summary"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "badge", "closed", "subtitle", "active"],
  data: function() {
    return {
    };
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.title {
  text-transform: uppercase;
  font-weight: 500;
}
.ib-content,
.ib-content-summary {
  overflow: hidden;
  
}

.ib-content-summary {
  height: fit-content;
}

.ib-header {
  display: flex;
  align-items: center;
  padding: 0 var(--outer-padding);

  :first-child {
    margin-right: 10px;
  }
}

.edit {
  cursor: pointer;
  color: #09f;
  margin-left: auto;
}

.infobox {
  // border: 1px solid var(--border-color);
  background: #fff;
  box-shadow: 0px 1px 3px #00000029;
  padding: var(--outer-padding) 0;
  overflow: hidden;
  background: #fff;
  border-radius: var(--card-border-radius);

  .ib-header {
  }

  // mobile
  @media only screen and (max-width: 942px) {
    border-radius: 0px;
    padding: var(--outer-padding) 0;
  }
}

.infobox.inactive {
}

.infobox-badge {
  height: 21px;
  width: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: black;
  color: white;
}

.subtitle {
  color: var(--border-color);
  font-size: 14px;
}
</style>
